export enum ListSearchCriteriaType {
  AddressManagement = 'addressManagement',
  AllocationViewProfiles = 'allocationViewProfiles',
  ApiConnections = 'apiConnections',
  AutomotiveAftermarketProfiles = 'automotiveAftermarketProfiles',
  ClosedPeriods = 'closedPeriods',
  ShipmentPlannerProfiles = 'shipmentPlannerProfiles',
  Shipment = 'shipment',
  ShipmentTransportOrderMaterial = 'shipmentTransportOrderMaterials',
  CompartmentAssignedUsers = 'compartmentAssignedUsers',
  CompartmentRules = 'compartmentRules',
  Compartments = 'compartments',
  WaybillDataQuality = 'waybillDataQuality',
  Sc3DataQuality = 'Sc3DataQuality',
  Sc3FailedMessages = 'sc3FailedMessages',
  Sc4FailedMessages = 'sc4FailedMessages',
  Docks = 'docks',
  Dpns = 'dpns',
  DriverList = 'frequent-drivers',
  Eulas = 'eulas',
  FailedMessagesProfiles = 'failedMessagesProfiles',
  GoodsItems = 'goodsItems',
  HandlingUnitIds = 'handlingUnitIds',
  Hubs = 'hubs',
  LoanerPhones = 'loaner-phones',
  MasterDataReport = 'masterDataReport',
  Newsletters = 'newsletters',
  Partners = 'partners',
  TransportManagementProfiles = 'transportManagementProfiles',
  TransportPlannerProfiles = 'transportPlannerProfiles',
  Users = 'users',
  WaybillMaterials = 'waybillMaterials',
  AddressDataReport = 'addressDataReport',
  PartnersList = 'partnersList',
  Plants = 'plants',
  Sc3FailedMessagesExport = 'sc3FailedMessagesExport',
  Sc4FailedMessagesExport = 'sc4FailedMessagesExport',
  Exports = 'exports',
  TruckDrivers = 'truckDrivers',
  DeletionHistory = 'deletionHistory',
  CouplingPlan = 'couplingPlan',
  YardSpots = 'yardSpots',
}
